import React from 'react';
import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useEffect, useRef, useState} from 'react';
import {useAuth} from '../../hooks/useAuth';
import {useHistory} from 'react-router-dom';
import _ from 'lodash';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import Search from '../../assets/icons/Search';
import Button from '../../common/components/Button/Button';
import Table from '../../common/components/ItemTable/v2/Table';
import Loading from '../../common/components/Loading/Loading';
import CustomAlert from '../../common/components/Alert/CustomAlert';
import Trash from '../../assets/icons/Trash';
import Lock from '../../assets/icons/Lock';
import Pencil from '../../assets/icons/Pencil';
import {Tooltip} from "@mui/material";
import _Modal from "../../common/components/Modal/v2/Modal";
import Menu from "../../common/components/Menu/Menu";
import Chip from "../../common/components/Chip/v2/Chip";


const ProviderUsers = (props) => {
    const {
        name,
        columnData,
        title,
        getProviders,
        getProvidersMe,
        providers,
        providerListConfig,
        setListConfig,
        deleteProvider,
        setProviderSelected,
        resetPassEmail,
        userInfo,
        switchOfUser,
        getProvidersState,
        cleanBranches,
        cleanProvidersBranches,
        cleanListConfig,
        cleanBulkInsert,
        showSidebar,
    } = props;

    const [columnName, setColumnName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState(null);

    const [search, setSearch] = useState('');
    const [searchTag, setSearchTag] = useState('name');
    const [currentPage, setCurrentPage] = useState(-1);
    const [modalText, setModalText] = useState('');
    const [modalButtonAction, setModalButtonAction] = useState(null);
    const totalUsers = providers?.total
    const [pageQuantity, setPageQuantity] = useState(100); // todo: hardcoded
    const {isAdmin} = useAuth();

    const history = useHistory();


    const pushPage = (name) => {
        history.push(name);
    };

    const phoneNumbersCell = (params) => {
        return <div>
            {params.row.phoneNumbers.map((phone, index) =>
                <p>{phone.number}</p>,
            )}
        </div>;
    };

    const rolesDict = {
        'PROVIDER_ADMIN': 'Administrador',
        'PROVIDER_USER': 'Usuario de sede',
        'PROVIDER_USER_QUOTER': 'Usuario de sede - Cotización',
        'PROVIDER_USER_VIEWER': 'Usuario de sede - Consulta',
        'DEVELOPER': 'Desarrollador',
    };

    const tableHeaders = [
        {id: 'name', att: 'name', title: 'Nombre'},
        {
            id: 'email',
            title: 'Email',
            att: 'userEmail',
        },
        {
            id: 'phoneNumbers',
            att: 'phoneNumbers',
            title: 'Teléfono/s',
            renderCell: (params) => phoneNumbersCell(params),
        },
        {
            id: 'rol',
            title: 'Rol',
            att: 'userRole',
        },
        {id: 'provider', att: 'salesforceProviderName', title: 'Prestador'},
        {id: 'branch', att: 'salesforceBranchName', title: 'Sede'},
        {id: 'puedeVerMontos', att: 'puedeVerMontos', title: 'Ver Montos', sortable: false},
        ...(isAdmin ? [{
            id: 'trash',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => providerButtons(params.row),
        }] : []),
    ];

    const providerButtons = (data) => {
        return (
            <div className={'flex-aligned-justified-center'} style={{gap: '8px'}}>
                {data.id !== userInfo.id &&
                    <Tooltip title={'Eliminar'}>
                        <div className={'cursor-pointer'} onClick={() => handleDelete(data)}>
                            <Trash width={'14px'} height={'14px'}/>
                        </div>
                    </Tooltip>
                }
                <Tooltip title={'Cambiar contraseña'}>
                    <div className={'cursor-pointer'} onClick={() => handleResetPass(data)}>
                        <Lock width={'14px'} height={'14px'}/>
                    </div>
                </Tooltip>
                <Tooltip title={'Editar'}>
                    <div className={'cursor-pointer'} onClick={() => handleEdit(data)}>
                        <Pencil width={'14px'} height={'14px'}/>
                    </div>
                </Tooltip>
            </div>
        );
    };

    const handleEdit = (provider) => {
        setProviderSelected(provider);
        pushPage('/provider/editUser');
    };


    const isInitialMount = useRef(true);

    const getProvidersByRole = () => {
        if (userInfo.role.name === 'PROVIDER_ADMIN') {
            getProvidersMe();
        } else {
            getProviders();
        }
    };

    useEffect(() => {
        switchOfUser('Usuarios de Prestadores');
        cleanListConfig('providerListConfig');
        setCurrentPage(1);
        cleanBranches();
        cleanProvidersBranches();
        cleanBulkInsert();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isInitialMount.current || providerListConfig === undefined) {
            setListConfig({
                list: 'providerListConfig',
                config: {page: currentPage},
            });
            getProvidersByRole();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        if (currentPage > pageQuantity) setCurrentPage(pageQuantity);
        // eslint-disable-next-line
    }, [providers]);


    const handleDelete = (provider) => {
        /*        setModalButtonAction(() => () => handleClickDelete(provider));
                setModalText('¿SEGURO QUE DESEA ELIMINAR ESTE PRESTADOR?');
                setShowModal(true);*/
        setModalInfo({
            title: 'Eliminar administrador',
            text: '¿Seguro que desea eliminar a este administrador?',
            buttonAction: () => handleClickDelete(provider),
            buttonText: 'Eliminar',
            handleClose: handleClose,
        });
        setShowModal(true);
    };

    const handleResetPass = (provider) => {
        /*        setModalButtonAction(() => () => handleClickResetPass(provider));
                setModalText('¿SEGURO QUE DESEA RESTABLECER LA CONTRASEÑA DE ESTE PRESTADOR?');
                setShowModal(true);*/
        setModalInfo({
            title: 'Cambiar contraseña',
            text: '¿Seguro que desea restablecer la contraseña del prestador? Esto le enviará un mail para que pueda restaurarla',
            buttonAction: () => handleClickResetPass(provider),
            buttonText: 'Restablecer',
            handleClose: handleClose,
        });
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleClickDelete = (provider) => {
        deleteProvider(provider.id, provider.user.role.name === 'PROVIDER_USER' ? 'user' : 'admin');
        handleClose();
    };

    const handleClickResetPass = (provider) => {
        resetPassEmail({email: provider.user.email});
        handleClose();
    };

    const handleSearch = () => {
        const searchTags = {...providerListConfig.searchTags, [searchTag || 'name']: search};

        setListConfig({
            list: 'providerListConfig',
            config: {search: search, searchTags},
        });
        getProvidersByRole();

        setSearch('');
    };

    const deleteSearchTag = (tag) => {
        const searchTags = _.omit(providerListConfig?.searchTags, [tag]);

        setListConfig({
            list: 'providerListConfig',
            config: {search: search, searchTags},
        });
        getProvidersByRole();
    };

    const tagNames = {
        name: 'Nombre',
        email: 'Email',
        salesforceProviderName: 'Prestador',
        salesforceBranchName: 'Sede',
    };

    const optimizedRows = providers?.result?.map((provider) => {
        return {
            ...provider,
            userEmail: provider.user?.email || 'N/A',
            userRole: rolesDict[provider.user?.role?.name] || 'No role',
            puedeVerMontos: provider.salesforceBranchId
                ? (provider.verMontoValidador ? 'Sí' : 'No')
                : '-',
        };
    });

    return (
        <div className={'page-content-container'}>
            <p className={'h3 v2-c-text-title'}>Usuarios de prestadores</p>
            <div className={'page-table-container'}>
                <div className="page-table-options">
                    <div className={'filter-container'}>
                        <form onSubmit={(event) => {
                            handleSearch();
                            event.preventDefault();
                        }}>
                            <CustomInput placeholder={`Buscar por ${tagNames[searchTag]}... `}
                                         value={search}
                                         onChange={(e) => setSearch(e.replace(/[^@\w\s.]/gi, ''))}
                                         leftSlot={<Search/>}
                            />
                        </form>
                        <Menu selected={tagNames[searchTag]} items={tagNames} onClick={(value) => setSearchTag(value)}/>
                        <div>
                            {providerListConfig?.searchTags && Object.keys(providerListConfig?.searchTags).map((key) =>
                                <Chip
                                    key={key}
                                    text={tagNames[key] + ': ' + providerListConfig?.searchTags[key]}
                                    deleteOnClick={() =>
                                        deleteSearchTag(key)
                                    }
                                />,
                            )
                            }
                        </div>
                    </div>
                    {isAdmin &&
                        <div className={'flex-aligned-justified-center gap-8'}>
                            <Button size={'small'} onClick={() => pushPage('/provider/add')}>Nuevo</Button>
                            <Button size={'small'} onClick={() => pushPage('/provider/bulkInsert')}>Carga masiva</Button>
                        </div>
                    }
                </div>
                <div style={{height: '500px'}}>
                    {getProvidersState?.success ?
                        <Table attributes={tableHeaders} rows={optimizedRows} currentPage={currentPage}
                               onPageChange={(value) => setCurrentPage(value)} rowCount={totalUsers}
                               pageSize={pageQuantity}/> :
                        getProvidersState?.loading ? <Loading className="ul-div-sect-table"/> :
                            <CustomAlert text={'administradores' || String(getProvidersState.error)} severity='error'/>
                    }
                </div>
                {showModal && (
                    <_Modal
                        showModal={showModal}
                        handleClose={modalInfo?.handleClose}
                        handleClick={modalInfo?.buttonAction}
                        modalTitle={modalInfo?.title}
                        modalButtonText={modalInfo?.buttonText}
                        modalText={modalInfo?.text}
                    />
                )}
            </div>
        </div>
    );
};


const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    columnData: state.home.columnData,
    title: state.home.title,
    providers: state.home.providers,
    userInfo: state.login.userInfo,
    providerListConfig: state.home.providerListConfig,
    getProvidersState: state.home.getProvidersState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getProviders: () => dispatch(actions.home.getProvidersRequest()),
    getProvidersMe: () => dispatch(actions.home.getProvidersMeRequest()),
    deleteProvider: (id, providerType) => dispatch(actions.home.deleteProviderRequest(id, providerType)),
    setProviderSelected: (providerSelected) => dispatch(actions.home.setProviderSelected(providerSelected)),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    resetPassEmail: (body) => dispatch(actions.login.resetPassEmailRequest(body)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
    cleanBulkInsert: () => dispatch(actions.home.cleanBulkInsert()),
});

ProviderUsers.propTypes = {
    name: PropTypes.string,
    columnData: PropTypes.object,
    title: PropTypes.string,
    getProviders: PropTypes.func,
    getProvidersMe: PropTypes.func,
    deleteProvider: PropTypes.func,
    userInfo: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProviderUsers);
